import type {
  ClientAppVariantVersionCheckResult,
  ClientGlobalRoleAssignment
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { createContext, useContext } from 'react';

export type AppStateContextValues = {
  userId: string;
  userEmail: string;
  userAuthFirstName?: string;
  userAuthLastName?: string;
  homeGeoAreaId?: string;
  hasRequiredAction: boolean;
  canUseApp: boolean;
  hasProfile: boolean;
  hasHomeGeoArea: boolean;
  hasAcceptedTerms: boolean;
  hasValidVersion: boolean;
  versionCheckResult?: ClientAppVariantVersionCheckResult;
  isNotReachableError: boolean;
  isOnboardingStatusRefetching: boolean;
  updateAppStates: () => void;
  isEmergencyOrganization: (id?: string) => boolean;
  /**
   * The global (entity-independent) role assignments the current user holds. Any
   * of these grants full organization-admin access and takes priority over
   * per-organization roles.
   */
  globalRoles: ClientGlobalRoleAssignment[];
};

const defaultContextValues: AppStateContextValues = {
  userId: '',
  userEmail: '',
  homeGeoAreaId: '',
  hasRequiredAction: false,
  canUseApp: false,
  hasProfile: false,
  hasHomeGeoArea: false,
  hasAcceptedTerms: false,
  hasValidVersion: false,
  versionCheckResult: undefined,
  isNotReachableError: false,
  isOnboardingStatusRefetching: false,
  updateAppStates: () => {},
  isEmergencyOrganization: () => false,
  globalRoles: []
};

export const AppStateContext =
  createContext<AppStateContextValues>(defaultContextValues);
export const useAppState = () => useContext(AppStateContext);
